module.exports = __webpack_public_path__ + "statics/img/6.7b3e22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/6.png
// module id = Q04z
// module chunks = 1